
import React from "react";
import { Editor } from "@tiptap/react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogHeader,
} from "@/components/ui/dialog";
import ImageForm from "../ImageForm";

interface ImageDialogProps {
  editor: Editor;
  uploadImage?: (file: File) => Promise<string>;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

const ImageDialog = ({ editor, uploadImage, isOpen, setIsOpen }: ImageDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Insert Image</DialogTitle>
        </DialogHeader>
        <ImageForm
          editor={editor}
          uploadImage={uploadImage}
          onClose={() => setIsOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageDialog;
